<template>
  <router-link :to="{name: targetName}" class="flex flex-col items-center flex-1 relative">
    <div class="h-8 w-8 relative rounded-full overflow-hidden bg-cover" :class="{'bg-black': !icon}" :style="style">
      <div v-html="iconHtml" v-if="icon && !image"></div>
    </div>
    <div class="my-1 text-center text-xxs">
      {{label}}
    </div>
    <div v-if="number > 0" class="h-4 w-4 absolute top-0 ml-3 bg-red-600 text-xxs rounded-full text-white flex items-center justify-center">
      {{Math.min(number, 99)}}
    </div>
  </router-link>
</template>

<script>

import { icons, getIconHtml } from '@/services/icons'

export default {
  props: {
    targetName: String,
    image: String || Boolean,
    label: String,
    icon: String, 
    number: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconHtml() {
      if(this.icon && icons[this.icon]) {
        return getIconHtml(icons[this.icon], 32)
      } 
      return ''
    },
    style() {
      if(this.image) {
        return {backgroundImage: `url('${this.image}')`}
      } else {
        return false
      }
    }
  }
}
</script>

<style>

</style>